import api from './config'

interface ForgotParams {
  email: string
}

interface VerifyParams {
  email: string
  code: string
}

interface ResetParams {
  token: string
  password: string
  password_confirmation: string
}

interface VerifyResponse {
  token: string
}

const passwordsAPI = {
  forgot: async (data: ForgotParams) => {
    const response = await api.post('/passwords', data)
    return response.data
  },

  verify: async (data: VerifyParams) => {
    const response = await api.post<VerifyResponse>('/passwords/verify', data)
    return response.data
  },

  reset: async (data: ResetParams) => {
    const response = await api.put(`/passwords/${data.token}`, {
      password: data.password,
      password_confirmation: data.password_confirmation
    })
    return response.data
  }
}

export default passwordsAPI